// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"eb14eb01","112":"69216b2a","453":"0ea56297","461":"435a7f6b","526":"8b8f8712","591":"7902b886","694":"64581f0f","718":"312ed698","885":"d25b3cb4","931":"9cf47b91"}[chunkId] + ".chunk.js";
};